exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pdf-viewer {\n  text-align: center; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/client/invoices/detail/detail.component.scss
// module id = ../../../../../app/src/app/client/invoices/detail/detail.component.scss
// module chunks = invoices.module.0